/**
 * The voice input's colors: the AI pages' palette (ai-suite `aiColors`),
 * which the voice composer was drawn in first; kept here, since a shared
 * component cannot read a feature's theme.
 */
export const voiceInputColors = {
  foreground: '#0F172A',
  primary: '#1A6FD8',
  primaryForeground: '#FFFFFF',
  muted: '#EDF1F6',
  mutedForeground: '#64748B',
  card: '#FFFFFF',
  border: '#E2E8F0',
  input: '#F1F5F9',
};
